import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=316d4463&"
import script from "./Title.vue?vue&type=script&lang=ts&"
export * from "./Title.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})


/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('316d4463')) {
      api.createRecord('316d4463', component.options)
    } else {
      api.reload('316d4463', component.options)
    }
    module.hot.accept("./Title.vue?vue&type=template&id=316d4463&", function () {
      api.rerender('316d4463', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaignFactory/Title.vue"
export default component.exports